module.exports = __webpack_public_path__ + "img/vape-shop-custom-website.be51337c.jpeg";